<template>
  <div class="modal" v-bind:class="{ 'is-active': show }">
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 70% !important; height: 81% !important;">
      <header class="modal-card-head hero">
        <div class="columns">
          <div class="column is-6">
            <h1 class="title">Crear Consolidado</h1>
          </div>
          <div class="column is-6" style="text-align: end">
            <button aria-label="close" class="delete" @click="close"></button>
          </div>
        </div>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column is-12">
            <div class="columns">
              <div class="column">
                <p class="control has-icons-left has-icons-right">
                  <input
                      class="input is-medium is-focused"
                      type="text"
                      v-model="search"
                      placeholder="Filtrar "
                  />
                  <span class="icon is-medium is-left">
          <i class="material-icons">search</i>
        </span>
                </p>
              </div>
            </div>
            <div class="is-block scroll-table scroll-light is-white">
              <table class="table is-fullwidth">
                <thead class="head-stick">
                <tr>
                  <th>{{ filteredItems.length }}</th>
                  <th>✓</th>
                  <th>Proceso</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(k,v) in filteredItems" :key="v">
                  <td style="width: 5%">{{ v + 1 }}</td>
                  <td style="width: 5%"><input class="is-dark is-medium" type="checkbox" :name="k" :id="v"
                                               v-model="union[k._id]">
                  </td>
                  <td>{{ k.nombre }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot columns">
        <div class="column is-6">
          <button class="button"
                  @click="close">
            Cerrar
          </button>
        </div>
        <div class="column is-6">
          <div class="is-flex is-justify-end has-text-right">
            <div class="field has-addons" style='width: 100% !important;'>
              <div class="control" style='width: 100%'>
                <input class="input" v-model="union['name']" type="text" style='width: 100%'
                       placeholder="Nombre del nuevo proceso"/>
              </div>
              <button class="button is-dark" id="btnsave" @click="save">
                Guardar
              </button>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";

const filterItems = (query, data) => {
  return data.filter((el) => {
    const texto = el.nombre
    if (texto.toLowerCase().indexOf(query.toLowerCase()) > -1) {
      return el;
    }
  });
};

export default {
  data() {
    return {
      search: "",
      union: {}
    }
  },
  computed: {
    filteredItems: function () {
      return filterItems(this.search, this.listProcesses);
    },
  },
  props: {
    show: Boolean,
    listProcesses: Array
  },
  methods: {
    close() {
      this.$emit('closeModal')
    },
    save() {
      try {
        if (this.union.name && Object.keys(this.union).length > 2) {
          apiServices.post('/unionprocesos', this.union).then(value => {
            if (value.data) {
              this.$store.dispatch("notify", {
                message: "Consolidado creado correctamente.",
              });
              this.$emit('getProcesses')
              this.close()
            }
          })
        } else {
          this.$store.dispatch("notify", {
            message: `Debes elegir los procesos y darle un nombre nuevo al consolidado`,
            type: "is-danger",
          });
        }
      } catch (err) {
        console.log(err)
        this.$store.dispatch("notify", {
          message: `Hubo un problema no se crear el consolidado`,
          type: "is-danger",
        });
      }
    }
  },
  created() {
  }
}
</script>

<style>
textarea {
  resize: none;
  overflow: hidden;
  box-shadow: inset 0 0 0 rgb(10 10 10 / 10%);
}
</style>



// WEBPACK FOOTER //
// src/components/modals/ModalConsolidado.vue